// extracted by mini-css-extract-plugin
module.exports = {"center":"Loader_center__2JTaE","Loader":"Loader_Loader__WfRYz","lds-ripple":"Loader_lds-ripple__19PTH"};